var map = {
	"./aia.svg": 1373,
	"./ant.svg": 1374,
	"./aus.svg": 1375,
	"./bah.svg": 1376,
	"./ban.svg": 1377,
	"./bar.svg": 1378,
	"./ber.svg": 1379,
	"./biz.svg": 1380,
	"./bot.svg": 1381,
	"./bru.svg": 1382,
	"./can.svg": 1383,
	"./cay.svg": 1384,
	"./cmr.svg": 1385,
	"./cok.svg": 1386,
	"./cyp.svg": 1387,
	"./dma.svg": 1388,
	"./eng.svg": 1389,
	"./fij.svg": 1390,
	"./flk.svg": 1391,
	"./gab.svg": 1392,
	"./gam.svg": 1393,
	"./ggy.svg": 1394,
	"./gha.svg": 1395,
	"./gib.svg": 1396,
	"./grn.svg": 1397,
	"./guy.svg": 1398,
	"./ind.svg": 1399,
	"./iom.svg": 1400,
	"./ivb.svg": 1401,
	"./jam.svg": 1402,
	"./jey.svg": 1403,
	"./ken.svg": 1404,
	"./kir.svg": 1405,
	"./lca.svg": 1406,
	"./les.svg": 1407,
	"./manifest.json": 768,
	"./mas.svg": 1408,
	"./maw.svg": 1409,
	"./mdv.svg": 1410,
	"./mlt.svg": 1411,
	"./moz.svg": 1412,
	"./mri.svg": 1413,
	"./msr.svg": 1414,
	"./nam.svg": 1415,
	"./nfk.svg": 1416,
	"./ngr.svg": 1417,
	"./nir.svg": 1418,
	"./niu.svg": 1419,
	"./nru.svg": 1420,
	"./nzl.svg": 1421,
	"./pak.svg": 1422,
	"./png.svg": 1423,
	"./rsa.svg": 1424,
	"./rwa.svg": 1425,
	"./sam.svg": 1426,
	"./sco.svg": 1427,
	"./sey.svg": 1428,
	"./sgp.svg": 1429,
	"./shn.svg": 1430,
	"./skn.svg": 1431,
	"./sle.svg": 1432,
	"./sol.svg": 1433,
	"./sri.svg": 1434,
	"./svg-country.svg": 1435,
	"./swz.svg": 1436,
	"./tan.svg": 1437,
	"./tca.svg": 1438,
	"./tga.svg": 1439,
	"./tog.svg": 1440,
	"./tto.svg": 1441,
	"./tuv.svg": 1442,
	"./uga.svg": 1443,
	"./van.svg": 1444,
	"./wal.svg": 1445,
	"./zam.svg": 1446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1372;